import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpResponse} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {AppConfig} from '../shared/app-config';
import {environment} from '../../environments/environment';
import {catchError, map, publishReplay, refCount} from 'rxjs/operators';
import {ErrorDataService} from './error-data.service';
import {TtsLocaleMap} from '../model/ttsLocaleMap';
import {factory} from '../shared/app-logging';

const logger = factory.getLogger('MapperService');

@Injectable({
  providedIn: 'root'
})
export class MapperService {

  private ttsLocaleMappingList: Observable<Array<TtsLocaleMap>>;
  private ttsLocaleMappingListLastCallError = false;

  constructor(private httpClient: HttpClient) {
  }

  getTtsLocaleMappingList(): Observable<Array<TtsLocaleMap>> {
    if (this.ttsLocaleMappingList && !this.ttsLocaleMappingListLastCallError) {
      logger.debug('getTtsLocaleMappingList: Cache hit.');
    }
    this.ttsLocaleMappingList = (this.ttsLocaleMappingList && !this.ttsLocaleMappingListLastCallError) ?
      this.ttsLocaleMappingList : this.fetchTtsLocaleMappingList();
    return this.ttsLocaleMappingList;
  }

  private fetchTtsLocaleMappingList(): Observable<Array<TtsLocaleMap>> {
    const urlService = AppConfig.urlTtsLocaleMappers;
    return this.httpClient.get(environment.contentLibraryApiBaseUrl + urlService)
      .pipe(map(
        (response: HttpResponse<any>) => {
          const mappings = new Array<TtsLocaleMap>();
          if (response['data']) {
            for (const item of response['data']) {
              mappings.push(new TtsLocaleMap(item.tts_locale_mapper_id, item.xcore_locale, item.tts_polly_locale));
            }
          }
          logger.debug(`getTtsLocaleMappingList: ${mappings.length} mappings fetched from REST`);
          this.ttsLocaleMappingListLastCallError = false;
          return mappings;
        }
        ), catchError((err: Error | HttpErrorResponse) => {
          const message = `In MapperService.getLocaleMappingList().`;
          this.ttsLocaleMappingListLastCallError = true;
          return throwError(ErrorDataService.overLoadError(err, message));
        }),
        publishReplay(1),
        refCount());
  }

  // getTtsXcoreLocales(polly_locale): Observable<Array<TtsLocaleMap>> {
  //
  //   const urlService = AppConfig.urlTtsXcoreLocales;
  //   return this.httpClient.get(environment.contentLibraryApiBaseUrl + urlService)
  //     .pipe(map(
  //       (response: HttpResponse<any>) => {
  //         const mappings = new Array<TtsLocaleMap>();
  //         if (response['data']) {
  //           for (const item of response['data']) {
  //             mappings.push(new TtsLocaleMap(item.tts_locale_mapper_id, item.xcore_locale, item.tts_polly_locale));
  //           }
  //         }
  //         return mappings;
  //       }
  //     ), catchError((err: Error | HttpErrorResponse) => {
  //       const message = `In MapperService.getLocaleMappingList().`;
  //       return throwError(ErrorDataService.overLoadError(err, message));
  //     }));
  // }
  //
  // getTtsPollyLocale(xcore_locale): Observable<TtsLocaleMap> {
  //
  //   const urlService = AppConfig.urlTtsPollyLocale;
  //   return this.httpClient.get(environment.contentLibraryApiBaseUrl + urlService)
  //     .pipe(map(
  //       (response: HttpResponse<any>) => {
  //         if (response['data']) {
  //           const item = response['data'];
  //           return new TtsLocaleMap(item.tts_locale_mapper_id, item.xcore_locale, item.tts_polly_locale);
  //         }
  //       }
  //     ), catchError((err: Error | HttpErrorResponse) => {
  //       const message = `In MapperService.getLocaleMappingList().`;
  //       return throwError(ErrorDataService.overLoadError(err, message));
  //     }));
  // }
}
